module.exports = __webpack_public_path__ + "img/home-section-img.959e5b69.jpg";